export default __webpack_public_path__ + "static/media/CloseButton.c5a1ca12.svg";